import React from 'react'
import './App.scss'
import {CssBaseline, ThemeProvider } from '@mui/material'
import { BrowserRouter} from 'react-router-dom'
import AppRouter from './routes/AppRouter'
import theme from './themes/main/theme'
import useSnacks from './hooks/useSnacks'
import {IntlProvider} from 'react-intl';
import {messages} from './i18n/messages';
import {LOCALES} from './i18n/locales';
import {MomentProvider} from './contexts/moment-context';
import {ThemeContextProvider} from './contexts/theme-context';

function App() {
    const locale = LOCALES.ENGLISH;
    useSnacks()
    return (
        <div className="App">
            <ThemeContextProvider>
                <IntlProvider messages={messages[locale]} locale={locale} defaultLocale={LOCALES.ENGLISH}
                    fallbackOnEmptyString={true}>
                    <CssBaseline/>
                    <ThemeProvider theme={theme}>
                        <MomentProvider locale={locale}>
                            <BrowserRouter>
                                <AppRouter/>
                            </BrowserRouter>
                        </MomentProvider>
                    </ThemeProvider>
                </IntlProvider>
            </ThemeContextProvider>
        </div>
    )
}

export default App
